import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import API from '../../../create/api';
import { useStore } from 'react-redux';
import querystring from 'querystring';
import _ from 'lodash';
import Grid from '@material-ui/core/Grid';
import moment from 'moment';
import { styled } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { type SelectChangeEvent } from '@mui/material/Select';
import Chip from '@mui/material/Chip';
import Rider from '../../../fields/rider';
import ScrollArrow from '../../../../components/scrollArrow';

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 700,
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  fromControl: {
    width: '100%',
  },
  createButton: {
    paddingBottom: theme.spacing(2),
  },
  centerAlign: {
    textAlign: 'center',
    'span &': {
      verticalAlign: 'middle',
    },
  },
}));
const Item = styled(Paper)(({ theme }: any) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
function DepositIndex(props: any) {
  const classes = useStyles();
  const store = useStore();

  const [rows, setRows]: any = useState([]);
  const [get_payment_date, set_payment_date]: any = useState(moment().tz('Asia/Dhaka').format('YYYY-MM-DD'));
  const [rider, setRider]: any = useState(null);

  function getParcelByPaymentDate() {
    const paramObj: Record<string, any> = {
      payment_date: get_payment_date,
      _sort: 'id:ASC',
      status_in: get_status,
      rider: rider?.value,
      _limit: 1000,
    };
    const param = querystring.encode(_.pickBy(paramObj, _.identity));
    API.getAll(`${process.env.REACT_APP_API_SERVER}/parcels?${param}`).then((res: any) => {
      const rows = res;
      let sumDC = 0;
      let sumAmount = 0;
      let sumMerchantCOD = 0;
      for (let i = 0; i < rows.length; i++) {
        const { deliveryCharge, amount, merchant_COD } = rows[i];
        sumDC += deliveryCharge;
        sumAmount += amount;
        sumMerchantCOD += merchant_COD;
      }

      const table = { rows: res, sumDC, sumAmount, sumMerchantCOD };
      setRows(table);
    });
  }

  const [get_status, set_status]: any = React.useState(['DELIVERED']);
  const handleChange = (event: SelectChangeEvent) => {
    const {
      target: { value },
    } = event;
    set_status(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  return (
    <Grid container>
      <ScrollArrow />
      <Grid item xs={12} md={3}>
        <Item>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DesktopDatePicker
              label="Payment Date"
              inputFormat="yyyy-MM-dd"
              onChange={(newValue: Date | null) => {
                set_payment_date(moment(newValue).format('YYYY-MM-DD'));
              }}
              value={get_payment_date}
              renderInput={(params) => <TextField variant="standard" fullWidth {...params} />}
            />
          </LocalizationProvider>
        </Item>
      </Grid>

      <Grid item xs={12} md={3}>
        <FormControl sx={{ m: 1, width: '100%' }}>
          <InputLabel id="demo-multiple-chip-label">Status</InputLabel>
          <Select
            labelId="demo-multiple-chip-label"
            id="demo-multiple-chip"
            multiple
            value={get_status}
            onChange={handleChange}
            input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
            renderValue={(selected) => {
              return (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                  {(selected as unknown as unknown[] as string[]).map((value) => (
                    <Chip key={value} label={value} />
                  ))}
                </Box>
              );
            }}
            MenuProps={MenuProps}
          >
            {store.getState().parcel?.parcelStatus?.map((v: any, index: number) => (
              <MenuItem key={`${v.label}-${index}-Select-item`} value={v.value}>
                {v.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} md={3}>
        <div style={{ margin: '0 15px' }}>
          <Rider onChange={(cp: any) => setRider(cp ?? null)} />
        </div>
      </Grid>

      <Grid item xs={12} md={3}>
        <div style={{ alignItems: 'center', display: 'flex', justifyContent: 'center' }}>
          <Button
            size="small"
            variant="contained"
            color="primary"
            onClick={() => {
              getParcelByPaymentDate();
            }}
          >
            Search
          </Button>
        </div>
      </Grid>
      <Grid item xs={12} className={classes.createButton}>
        <TableContainer component={Paper}>
          <Table className={classes.table} aria-label="a spanning dense table" padding="checkbox">
            <TableHead>
              <TableRow>
                <TableCell>#</TableCell>
                <TableCell>APN</TableCell>
                <TableCell>Booking Date</TableCell>
                <TableCell align="left">Company</TableCell>
                <TableCell align="left">Rider</TableCell>
                <TableCell align="right">Status</TableCell>
                <TableCell align="right">COD</TableCell>
                <TableCell align="right">DC</TableCell>
                <TableCell align="right">Account</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows?.rows?.map((row: any, index: number) => (
                <TableRow key={row.id}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{row.id}</TableCell>
                  <TableCell>{moment(row.created_at).format('DD/MMM/YY')}</TableCell>
                  <TableCell align="left">{row.company?.name ?? ''}</TableCell>
                  <TableCell align="left">{row.rider?.name ?? ''}</TableCell>
                  <TableCell align="right">{row.status}</TableCell>
                  <TableCell align="right">{row.merchant_COD}</TableCell>
                  <TableCell align="right">{row.deliveryCharge}</TableCell>
                  <TableCell align="right">{row.amount}</TableCell>
                </TableRow>
              ))}
              <TableRow>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell align="right">
                  <b>{rows.sumMerchantCOD}</b>
                </TableCell>
                <TableCell align="right">
                  <b>{rows.sumDC}</b>
                </TableCell>
                <TableCell align="right">
                  SubTotal:<b>{rows.sumAmount}</b>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell align="right">
                  Total:<b>{rows.sumAmount + rows.sumDC}</b>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
}

export default withRouter(DepositIndex);
